import { Icon } from '../Icon';

import type { ButtonProps, ButtonVariant } from './Button.types';

import { S } from './Button.styles';

const getIconColor = (variant: ButtonVariant) => {
  switch (variant) {
    case 'primary':
      return 'white-50';
    case 'secondary':
      return 'charcoal-500';
    case 'tertiary':
      return 'charcoal-500';
  }
};

export const Button = ({
  label = 'Button',
  variant = 'primary',
  onClick,
  fullWidth = false,
  disabled = false,
  type = 'button',
  ariaLabel,
  tabIndex = 0,
  prefixIcon,
  suffixIcon,
  rotation,
  ...props
}: ButtonProps) => {
  return (
    <S.Button
      type={type}
      variant={variant}
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel || label}
      tabIndex={tabIndex}
      $fullWidth={fullWidth}
      {...props}
    >
      {prefixIcon && (
        <Icon name={prefixIcon} color={getIconColor(variant)} size="medium" rotation={rotation} />
      )}
      <S.Label>{label}</S.Label>
      {suffixIcon && (
        <Icon name={suffixIcon} color={getIconColor(variant)} size="medium" rotation={rotation} />
      )}
    </S.Button>
  );
};
